import { ReactNode, useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'core/common/hooks';
import { stickyFooterHeightCssVar } from 'core/theme/constants';
import { FooterLayoutStyled, FooterLayoutBodyStyled } from './styled';

type StickyFooterProps = {
  children: ReactNode;
  isHidden?: boolean;
};

export const StickyFooter = ({ children, isHidden }: StickyFooterProps) => {
  const footerRef = useRef<HTMLDivElement>(null);

  useIsomorphicLayoutEffect(() => {
    const footer = footerRef.current;
    if (!footer) return;

    const root = document.documentElement;
    const publishHeight = () =>
      root.style.setProperty(stickyFooterHeightCssVar, `${footer.offsetHeight}px`);

    publishHeight();
    const observer = new ResizeObserver(publishHeight);
    observer.observe(footer);

    return () => {
      observer.disconnect();
      root.style.removeProperty(stickyFooterHeightCssVar);
    };
  }, []);

  return (
    <FooterLayoutStyled ref={footerRef} isHidden={isHidden}>
      <FooterLayoutBodyStyled maxWidth="container">{children}</FooterLayoutBodyStyled>
    </FooterLayoutStyled>
  );
};
